/**
 * Module dependencies
 */
const React = require('react');
const PropTypes = require('prop-types');
const { Script } = require('nordic/script');
const Style = require('nordic/style');
const Head = require('nordic/head');
const Page = require('nordic/page');

const GeneralError = require('./components/GeneralError');
// const { EmptyStateWithIcon } = require('@andes/empty-state');

const { getStyleFile } = require('../../utils');

const View = (props) => {
  const { errorContext, platform: { id: business }, device: { webView } } = props;
  const { heading, title, description, link: baseLink, status } = errorContext;

  // const ComponentToRender = status === 500 ? ErrorScreen : EmptyStateWithIcon;
  const ComponentToRender = GeneralError;
  const handleClick = (e) => {
    e.preventDefault();
    window.location.replace(baseLink.href);
  };

  const link = baseLink && { ...baseLink, onClick: handleClick };

  return (
    <Page name="error" deviceType={webView && 'mobile'} styles={false}>
      <Style href={getStyleFile('error', business, webView)} />
      <Script src="vendor.js" />
      <Script>
        {`
          var agentKey = '_perfill';
          window[agentKey] = window[agentKey] || function (...args) {
            (window[agentKey].q = window[agentKey].q || []).push(args);
          };
          var perfillAgent = window[agentKey];
          perfillAgent('queue', 'start-recording', {
            traceability_id: 'error',
          });
        `}
      </Script>
      <Head>
        <title>{heading || 'Error'}</title>
      </Head>
      <ComponentToRender
        title={title}
        description={description}
        link={link}
        status={status}
      />
    </Page>
  );
};

/**
 * Define props
 */
View.propTypes = {
  errorContext: PropTypes.shape({
    title: PropTypes.string,
    heading: PropTypes.string,
    description: PropTypes.string,
    status: PropTypes.string,
    link: PropTypes.shape({
      text: PropTypes.string,
      href: PropTypes.string,
    }),
  }).isRequired,
  device: PropTypes.objectOf(PropTypes.any).isRequired,
  platform: PropTypes.objectOf(PropTypes.any).isRequired,
};

View.defaultProps = {};

module.exports = View;
